import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import useScrollDetection from "../../hooks/useScrollDetection";
import { getListCategory } from "../../services/purchaseApi";
import { useMutation, useQuery } from "@tanstack/react-query";
import KonsultasiDokter from "../../assets/category-icons/icon-chat-doctor.png";
import { useContext } from "react";
import { GlobalStateContext } from "../../components/context/GlobalStateContext";
import { useNotification } from "../../components/context/NotificationContext";
import {
  getDetailUserProfile,
  getListMyLocation,
} from "../../services/profileApi";
import { checkDoctorAvailability } from "../../services/telemedicineApi";
import { getLabelConfig } from "../../config/labelConfig";
import LoadingBackdrop from "../common/LoadingBackdrop";

const CategoryList = () => {
  const navigate = useNavigate();
  const isScrolled = useScrollDetection(5);
  const { isLogin, topicId } = useContext(GlobalStateContext);
  const { showNotification } = useNotification();
  const label = getLabelConfig();

  const { data: dataList } = useQuery({
    queryKey: ["list-my-location"],
    queryFn: () => getListMyLocation(),
    enabled: !!isLogin,
  });

  const { data: dataListCategory, isFetching: fetchingCategory } = useQuery({
    queryKey: ["category-list"],
    queryFn: () => getListCategory(),
    refetchOnWindowFocus: false,
  });

  const { data: dataProfile } = useQuery({
    queryKey: ["detail-user-profile"],
    queryFn: () => getDetailUserProfile(),
    enabled: isLogin === true,
    keepPreviousData: false,
  });

  const { mutate: mutateCheckDoctor, isPending: isLoadingCheckDoctor } =
    useMutation({
      mutationFn: checkDoctorAvailability,
      onSuccess: (data) => {
        if (!isLogin) {
          navigate("/profile");
        } else if (isLogin && dataList === null) {
          showNotification("Silahkan tambahkan alamat terlebih dahulu", "info");
          navigate("/location-address/my-address/new");
        } else if (dataProfile.nik === "0") {
          showNotification(
            "Silahkan tambahkan No. NIK terlebih dahulu",
            "info",
          );
          navigate("/profile/change");
        } else if (topicId && topicId.trim() !== "") {
          navigate(`/consultation/chat-with-doctor/${topicId}`, {
            state: { type: 2 },
          });
        } else {
          navigate("/consultation/detail-form", {
            state: {
              doctorData: data,
            },
          });
        }
      },
      onError: (err) => {
        if (err?.message === "Token expired") {
          showNotification("Silahkan login terlebih dahulu", "info");
          navigate("/profile");
        }
        showNotification(err?.message, "error");
      },
    });

  return (
    <div className="bg-white relative">
      <LoadingBackdrop isLoading={isLoadingCheckDoctor} />
      <div className="flex flex-row justify-center h-screen">
        <div className="w-full lg:w-1/2 flex justify-center lg:items-center px-0 lg:px-12 text-base">
          <div className="rounded-md px-4 lg:p-8 w-full h-fit">
            <div className="w-full">
              <div className="mt-6 mb-4">
                {!fetchingCategory ? (
                  <h1 className="font-medium text-base mb-4 text-slate-800">
                    Konsultasi
                  </h1>
                ) : (
                  <div className="animate-pulse h-5 rounded-md w-1/2 bg-slate-200 mb-4"></div>
                )}
                <div className="grid grid-cols-4 gap-x-4">
                  {!fetchingCategory ? (
                    <div
                      onClick={() => {
                        if (isLogin && dataList === null) {
                          navigate("/location-address/my-address/new");
                        } else
                          mutateCheckDoctor({
                            internal_only:
                              label.brandName === "Orlin" ? true : false,
                          });
                      }}
                      className="flex flex-col items-center p-1"
                    >
                      <div className="w-12 h-12 z-[98] mb-1">
                        <img src={KonsultasiDokter} alt="Konsultasi Dokter" />
                      </div>
                      <p className="text-center leading-tight text-sm font-medium text-slate-500">
                        Konsultasi Dokter
                      </p>
                    </div>
                  ) : fetchingCategory ? (
                    [1].map((item) => (
                      <div
                        key={item}
                        className="flex flex-col items-center p-1 animate-pulse"
                      >
                        <div className="w-12 h-12 bg-slate-200 rounded-lg mb-1"></div>
                        <div className="h-4 rounded-md w-3/4 bg-slate-200"></div>
                      </div>
                    ))
                  ) : null}
                </div>
              </div>
              <div className="mt-6 mb-4">
                {!fetchingCategory ? (
                  <h1 className="font-medium text-base mb-4 text-slate-800">
                    Keluhan Umum
                  </h1>
                ) : (
                  <div className="animate-pulse h-5 rounded-md w-1/2 bg-slate-200 mb-4"></div>
                )}
                <div className="grid grid-cols-4 gap-x-4">
                  {dataListCategory && !fetchingCategory
                    ? dataListCategory.map((item, idx) => (
                        <div
                          key={idx}
                          className="flex flex-col items-center p-1"
                          onClick={() =>
                            navigate(`/purchase/category/${item.id}`)
                          }
                        >
                          <div className="w-12 h-12 z-[98] mb-1">
                            <img src={item.icon_url} alt={item.name} />
                          </div>
                          <p className="text-center leading-tight text-sm font-medium text-slate-500">
                            {item.name}
                          </p>
                        </div>
                      ))
                    : fetchingCategory
                      ? [1, 2, 3, 4, 5, 6].map((item) => (
                          <div
                            key={item}
                            className="flex flex-col items-center p-1 animate-pulse"
                          >
                            <div className="w-12 h-12 bg-slate-200 rounded-lg mb-1"></div>
                            <div className="h-4 rounded-md w-3/4 bg-slate-200"></div>
                          </div>
                        ))
                      : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryList;
